<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
    >
      <p class="text1">欢迎体验标前狗会员</p>
      <p class="text2">
        请留下联系方式，我们会尽快联系您的体验大会员全部功能！
      </p>
      <p class="text3">
        <i class="el-icon-info icon"></i>
        温馨提示：请提供准确的信息，我们将为您推荐更准确，更个性化的商机和服务。
      </p>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <p class="title-text">基本信息</p>
        <div class="base-info">
          <el-form-item class="item" label="姓名:" prop="name">
            <el-input v-model="ruleForm.name" />
          </el-form-item>
          <el-form-item class="item" label="手机号:" prop="mobile">
            <el-input v-model="ruleForm.mobile" />
          </el-form-item>
        </div>
        <div class="line"></div>
        <p class="title-text">公司信息</p>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="ruleForm.companyName" />
        </el-form-item>

        <el-form-item label="公司类型" prop="companyType">
          <el-radio-group v-model="ruleForm.companyType">
            <el-radio :label="1">投标企业</el-radio>
            <el-radio :label="2">招标采购单位</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="line line2"></div>
        <div class="footer-item">
          <el-button class="btn" @click="resetForm('ruleForm')">
            暂不提供
          </el-button>
          <el-button class="btn" type="primary" @click="submitForm('ruleForm')">
            提 交
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { buyIntentsApi } from '@/api/value-added'

export default {
  name: 'FormPopup',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号格式不能为空'))
      }

      const reg = /^1[3-9]\d{9}$/
      setTimeout(() => {
        if (value.length == 11 && !reg.test(value)) {
          callback(new Error('手机号格式不正确'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      ruleForm: {
        name: '',
        mobile: '',
        companyName: '',
        companyType: []
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          {
            min: 1,
            max: 500,
            message: '长度在 1 到 500 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          buyIntentsApi(this.ruleForm)
            .then((res) => {
              this.$message.success('提交成功，客服人员会尽快与您联系!')
              this.dialogVisible = false
            })
            .catch((err) => {
              if (err?.data?.message) this.$message.error(err.data.message)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.dialogVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.text1 {
  font-size: 18px;
  @include text-bold;
  color: $text-color;
  text-align: center;
  margin-top: -20px;
  margin-bottom: 8px;
}
.text2 {
  font-size: 14px;
  color: $text-second-color;
  text-align: center;
  margin-bottom: 24px;
}
.text3 {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 7px 10px;
  font-size: 12px;
  color: $text-second-color;
  margin-bottom: 24px;
  background: $member-eighth-color;
  border-radius: 4px;
  border: 1px solid $member-sixth-color;
}
.title-text {
  font-size: 14px;
  @include text-bold;
  color: $text-color;
  margin-bottom: 16px;
}
.base-info {
  display: flex;
  .item {
    flex: 1;
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #eaeaea;
  margin-bottom: 24px;
  margin-top: 16px;
}
.line2 {
  margin-top: -10px;
}
.footer-item {
  display: flex;
  justify-content: center;
  .btn {
    width: 100px;
  }
}
.icon {
  color: $warning-color;
  font-size: 16px;
  margin-right: 5px;
}
::v-deep .el-radio__inner {
  border: 1px solid #d9d9d9;
}
</style>
